import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'anf-core-react';
import * as FormStructure from '../../FormStructure';
import { TmntText } from '../../Common';
import { emailUsFormTextV2 } from './emailUsPropTypes';

const modalId = 'continue-to-email-modal';

export default function ContinueToEmailModal({
  isOpen,
  onClose,
  text,
  handleOpenEmailClient,
}) {
  const {
    formGoToEmail,
    formYouAreTakenToEmail,
    formServiceRequestNote,
  } = text;

  const renderHeader = () => (
    <FormStructure.FormCell align="center">
      <div className="continue-to-email-modal__title" data-testid="continue-to-email-modal-header">
        <TmntText classNames="h1" tmnt={formYouAreTakenToEmail} />
      </div>
      <div className="continue-to-email-modal__note" data-testid="continue-to-email-modal-note">
        <TmntText tmnt={formServiceRequestNote} />
      </div>
    </FormStructure.FormCell>
  );

  const renderButton = () => (
    <FormStructure.FormCell align="center">
      <div data-testid="email-us-go-to-email-button">
        <Button
          variant="secondary"
          isFullWidth
          type="submit"
          onClick={handleOpenEmailClient}
        >
          <TmntText tmnt={formGoToEmail} />
        </Button>
      </div>
    </FormStructure.FormCell>
  );

  return (
    <Modal
      id={modalId}
      isOpen={isOpen}
      onClose={onClose}
      variant="headerless"
    >
      <FormStructure.FormWrapper>
        <FormStructure.FormGroup>
          {renderHeader()}
        </FormStructure.FormGroup>
        <FormStructure.FormGroup>
          {renderButton()}
        </FormStructure.FormGroup>
      </FormStructure.FormWrapper>
    </Modal>
  );
}

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  text: emailUsFormTextV2.isRequired,
  handleOpenEmailClient: PropTypes.func.isRequired,
};

ContinueToEmailModal.propTypes = propTypes;
